module.exports = __webpack_public_path__ + "img/rosen.d90df70e.png";